<template>
  <div class="settle-order-manage">
    <el-card shadow="always">
      <el-form ref="formInline" size="small" :model="filter" inline>
        <el-form-item label="平台审核状态" v-if="$myStore.state.user.userIdentity === 2">
          <el-select
            style="width: 200px"
            v-model="filter.auditStatus"
            placeholder="请选择"
          >
            <el-option label="全部" value="-1" />
            <el-option label="教务服务方初审中" :value="1" />
            <el-option label="教务服务方初审驳回" :value="2" />
            <el-option label="教务复审中" :value="3" />
            <el-option label="教务复审驳回" :value="4" />
            <el-option label="财务复审中" :value="5" />
            <el-option label="财务复审驳回" :value="6" />
            <el-option label="项目负责人复审" :value="7" />
            <el-option label="项目负责人复审驳回" :value="8" />
            <el-option label="分账审核通过" :value="9" />
          </el-select>
        </el-form-item>
        <el-form-item label="讯飞分账状态">
          <el-select
            style="width: 200px"
            v-model="filter.iflytekBalanceAudit"
            placeholder="请选择"
          >
            <el-option label="全部" value="-1" />
            <el-option v-for="item in flyAuditList" :key="item.status" :label="item.name" :value="item.status" />
          </el-select>
        </el-form-item>
        <el-form-item label="申请时间">
          <el-date-picker
            v-model="applyDate"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="验收单状态">
          <el-select
            style="width: 200px"
            v-model="filter.checkAcceptAudit"
            placeholder="请选择"
          >
            <el-option label="全部" value="-1" />
            <el-option label="教务服务方初审中" :value="1" />
            <el-option label="教务服务方初审驳回" :value="2" />
            <el-option label="教务复审中" :value="3" />
            <el-option label="教务复审驳回" :value="4" />
            <el-option label="财务复审中" :value="5" />
            <el-option label="财务复审驳回" :value="6" />
            <el-option label="审核通过" :value="7" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="$myStore.state.user.userIdentity === 0" label="关联教务服务方">
          <el-input v-model="filter.agentName" placeholder="" clearable />
        </el-form-item>
        <el-form-item v-if="$myStore.state.user.userIdentity !== 2" label="关联招生服务方">
          <el-input v-model="filter.distributionName" placeholder="" clearable />
        </el-form-item>
        <el-form-item label="结算订单编号">
          <el-input v-model="filter.id" placeholder="请输入结算订单编号" clearable />
        </el-form-item>
        <el-form-item style="margin-left: 50px">
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px" shadow="always">
      <el-radio-group v-model="filter.auditStatus" v-if="$myStore.state.user.userIdentity === 0" size="small" @input="handleSearch">
        <el-radio-button label="-1">全部</el-radio-button>
        <el-radio-button :label="3">教务复审</el-radio-button>
        <el-radio-button :label="5">财务复审</el-radio-button>
        <el-radio-button :label="7">项目负责人复审</el-radio-button>
        <el-radio-button :label="4">教务复审驳回</el-radio-button>
        <el-radio-button :label="6">财务复审驳回</el-radio-button>
        <el-radio-button :label="8">项目负责人复审驳回</el-radio-button>
      </el-radio-group>
      <el-radio-group v-model="filter.agentStatus" v-else-if="$myStore.state.user.userIdentity === 1" size="small" @input="handleSearch">
        <el-radio-button :label="1">全部</el-radio-button>
        <el-radio-button :label="2">待审核</el-radio-button>
        <el-radio-button :label="3">已提交</el-radio-button>
        <el-radio-button :label="4">初审驳回</el-radio-button>
      </el-radio-group>
      <el-table border v-loading="loading" :data="list" style="width:100%;margin-top:10px">
        <el-table-column label="结算订单编号" minWidth="180" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.id || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="关联教务服务方" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.agentName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="关联招生服务方" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.distributionName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="平台审核状态" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.auditStatus === 1">教务服务方初审中</span>
            <span v-else-if="row.auditStatus === 2">教务服务方初审驳回</span>
            <span v-else-if="row.auditStatus === 3">教务复审中</span>
            <span v-else-if="row.auditStatus === 4">教务复审驳回</span>
            <span v-else-if="row.auditStatus === 5">财务复审中</span>
            <span v-else-if="row.auditStatus === 6">财务复审驳回</span>
            <span v-else-if="row.auditStatus === 7">项目负责人复审中</span>
            <span v-else-if="row.auditStatus === 8">项目负责人复审驳回</span>
            <span v-else-if="row.auditStatus === 9">分账审核通过</span>
            <span v-else> -- </span>
          </template>
        </el-table-column>
        <el-table-column label="讯飞分账状态" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.iflytekBalanceAuditStr">{{ row.iflytekBalanceAuditStr }}</span>
            <span v-else> -- </span>
          </template>
        </el-table-column>
        <el-table-column label="验收单状态" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.checkAcceptAudit === 1">教务服务方初审中</span>
            <span v-else-if="row.checkAcceptAudit === 2">教务服务方初审驳回</span>
            <span v-else-if="row.checkAcceptAudit === 3">教务复审中</span>
            <span v-else-if="row.checkAcceptAudit === 4">教务复审驳回</span>
            <span v-else-if="row.checkAcceptAudit === 5">财务复审中</span>
            <span v-else-if="row.checkAcceptAudit === 6">财务复审驳回</span>
            <span v-else-if="row.checkAcceptAudit === 7">审核通过</span>
            <span v-else>未发起</span>
          </template>
        </el-table-column>
        <el-table-column label="申请单数" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.applyOrderNum }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单金额/元" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.applyOrderAmount || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="招生服务方结算金额/元" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.distributionAmount || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="$myStore.state.user.userIdentity !== 2" label="教务服务方结算金额/元" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.agentAmount || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="申请人" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.applyUserName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="申请时间" prop="applyDate" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.applyDate || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column width="308" fixed="right" align="center" label="操作">
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" @click="toRelevant(row)">关联订单</el-button>
            <el-button type="text" size="mini" @click="toBillDetail(row.id)">结算详情</el-button>
            <template v-if="row.auditStatus === 9">
              <template v-if="$myStore.state.user.userIdentity === 0">
                <el-button type="text" size="mini" @click="uploadReceipt(row)">上传银行回单</el-button>
              </template>
              <template v-else>
                <el-button type="text" size="mini" @click="toBillList(row)">生成结算单</el-button>
                <el-button type="text" size="mini" @click="toExpress(row)">上传发票单号</el-button>
                <el-button v-if="row.checkAcceptFlag === 2" type="text" size="mini" @click="toAddReceipt(row)">提交验收单</el-button>
              </template>
              <el-button type="text" size="mini" @click="toDownloadBill(row.id)">下载招生结算单</el-button>
            </template>
            <el-button v-if="checkAdmin()" type="text" size="mini" @click="updateConfig(row.id)">更新分账金额</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </el-card>
    <RelevantList ref="RelevantListEl" />
    <BillDetail ref="BillDetailEl" :filter="filter" :applyDate="applyDate" @refresh="handleGetListPage" />
    <BillEdList ref="BillEdListEl" />
    <ExpressInfo ref="ExpressInfoEl" @refresh="handleGetListPage" />
    <ReceiptInfo ref="ReceiptInfoEl" @refresh="handleGetListPage" />
    <DocProcess
      ref="DocProcessEl"
      title="下载招生结算单"
      contentTitle="招生销售结算单"
      :templatePath="`${$BASEURL}/docTemplate/zsxsjs.docx`"
      :info="docInfo"
    />
  </div>
</template>

<script>
import {
  pageByBillListPage,
  getIFlytekBalanceAuditList,
  addCheckAccept,
  billEnrollData,
  updateBillBalanceData
} from "@/api/orderAdmin/orderList";
import RelevantList from './components/relevantList.vue'
import BillEdList from './components/billedList.vue'
import BillDetail from './components/billDetail.vue'
import ExpressInfo from './components/expressInfo.vue'
import ReceiptInfo from './components/receiptInfo.vue'
import DocProcess from '@/components/docProcess'
import myPagination from "@/components/myPagination.vue"
import { processing } from "@/utils/handle.js"

export default {
  name: 'BillList',

  components: { RelevantList, BillDetail, BillEdList, ExpressInfo, ReceiptInfo, DocProcess, myPagination },
  data () {
    return {
      flyAuditList: [],
      filter: {
        auditStatus: '-1',
        iflytekBalanceAudit: '-1',
        checkAcceptAudit: '-1',
        agentStatus: 1,
        agentName: '',
        distributionName: '',
        applyStartDate: '',
        applyEndDate: '',
        id: ''
      },
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
      applyDate: [],
      loading: false,
      list: [],
      docInfo: {}
    }
  },
  created () {
    this.getIFlytekBalanceAuditList()
    this.handleGetListPage()
  },
  methods: {
    // 获取讯飞审核状态
    getIFlytekBalanceAuditList() {
      getIFlytekBalanceAuditList().then((res) => {
        if (res.code === 0) {
          this.flyAuditList = res.data || []
        }
      })
    },
    // 搜索
    handleSearch() {
      this.filter.page = 1
      this.handleGetListPage()
    },
    // 重置
    handleReset() {
      this.filter = this.$options.data().filter
      this.pageInfo = this.$options.data().pageInfo
      this.applyDate = []
      this.list = []
      this.getIFlytekBalanceAuditList()
      this.handleGetListPage()
    },
    handleGetListPage () {
      if (this.applyDate && this.applyDate.length !== 0)  {
        this.filter.applyStartDate = this.applyDate[0]
        this.filter.applyEndDate = this.applyDate[1]
      }
      const params = { ...processing(this.filter), ...this.pageInfo }
      params.flag = this.$myStore.state.user.userIdentity
      if (params.flag !== 1) {
        delete params.agentStatus
      }
      this.loading = true
      pageByBillListPage(params).then(({ code, data }) => {
        if (code === 0) {
          this.list = data.records
          this.pageInfo.total = +data.total
        }
      }).finally(() => {
        this.loading = false
      })
    },
    toRelevant(row) {
      this.$refs.RelevantListEl.init(row)
    },
    toBillDetail(id) {
      this.$refs.BillDetailEl.init(id)
    },
    toBillList(id) {
      this.$refs.BillEdListEl.init(id)
    },
    toExpress(row) {
      this.$refs.ExpressInfoEl.init(row)
    },
    // 上传银行回单
    uploadReceipt(row) {
      this.$refs.ReceiptInfoEl.init(row)
    },
    // 下载招生结算单
    toDownloadBill(id) {
      billEnrollData({ id }).then(({ code, data }) => {
        if (code === 0) {
          this.docInfo = {
            companyName: this.serializeData(data.companyName),
            number: this.serializeData(data.number),
            skuName: this.serializeData(data.skuName),
            month: this.serializeData(data.month),
            batchNo: this.serializeData(data.batchNo),
            num: this.serializeData(data.num),
            checkAcceptStandard: this.serializeData(data.checkAcceptStandard),
            serviceBond: this.serializeData(data.serviceBond),
            payBalanceAmt: this.serializeData(data.payBalanceAmt),
            accumulateNum: this.serializeData(data.accumulateNum),
            accumulateServiceBond: this.serializeData(data.accumulateServiceBond),
            insertName: this.serializeData(data.insertName),
            insertDate: this.serializeData(data.insertDate),
            agentAuditName: this.serializeData(data.agentAuditName),
            agentAuditDate: this.serializeData(data.agentAuditDate),
            educationalAuditName: this.serializeData(data.educationalAuditName),
            educationalAuditDate: this.serializeData(data.educationalAuditDate),
            projectAuditName: this.serializeData(data.projectAuditName),
            projectAuditDate: this.serializeData(data.projectAuditDate),
            financeAuditName: this.serializeData(data.financeAuditName),
            financeAuditDate: this.serializeData(data.financeAuditDate)
          }
          this.$refs.DocProcessEl.init()
        }
      })
    },
    serializeData (val) {
      if (val || val === 0 || val === '0') {
        return val
      }
      return '--'
    },
    // 更新结算单结算金额
    updateConfig (id) {
      this.$confirm(`是否确认更新分账金额?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await updateBillBalanceData({ id })
        if (res.code !== 0) {
          this.$message.error(res.message)
          return
        }
        this.$message.success('更新分账金额成功!')
        this.handleGetListPage()
      })
    },
    // 提交验收单
    toAddReceipt(row) {
      this.$confirm(`是否确认发起验收结算申请?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await addCheckAccept({ balanceId: row.id })
        if (res.code !== 0) {
          this.$message.error(res.message)
          return
        }
        this.$message.success('发起验收结算申请成功！')
        this.handleGetListPage()
      })
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.pageInfo.page = payload
      this.handleGetListPage()
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.pageInfo.limit = payload
      this.handleGetListPage()
    }
  }
}
</script>

<style>

</style>
